exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".eldo-component__container___3Rr-W {\n  font-family: \"Raleway\", \"HelveticaNeue\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin: 0 auto;\n  text-align: center;\n  width: 70%;\n}\n\n.eldo-component__container___3Rr-W hr {\n  border-top: 1px solid #8C8B8B;\n  margin: 50px 0;\n}\n\n.eldo-component__container___3Rr-W h4 {\n  text-align: left;\n}\n", ""]);

// exports
exports.locals = {
	"grey": "#8C8B8B",
	"container": "eldo-component__container___3Rr-W"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]&-autoprefixer!./node_modules/postcss-loader!./src/styles/eldo-component.css
// module id = 90
// module chunks = 0